var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"ma-3",attrs:{"indeterminate":"","color":"primary","size":30,"width":"2"}})}
var staticRenderFns = []

export { render, staticRenderFns }